import { useStore as getStore } from "../../utils/useStore.js";
import profileFactory from "./profileFactory.js";

const initialState = () => ({
  orderAscending: true,
  fieldToOrder: "Email",
  currentPage: 0,
  numberOfUsers: 0,
  loading: true,
  subUsers: [],
  removedSubUsers: [],
  selectedSubUser: {},
  sizeNumber: 5,
  searchTerm: '',
  statusFilter: undefined,
  permissionFilter: undefined,
  subUsersCounts: {},
});

const [ProfileProvider, useProfile, withProfile] = getStore(
  profileFactory,
  initialState,
  "Profile"
);

export const profileInitState = initialState();

export { useProfile, ProfileProvider, withProfile };

export default ProfileProvider;
